export const MEMBERS_AREA_TARGET = {
  V1: 'v1',
  V2: 'v2',
  V3: 'v3',
  EXTERNAL: 'external',
};

export const CAKTO_V3_DELIVERY_VALUE = 'cakto_v3';

/**
 * Lista as áreas de membros que o produto tem configuradas, na ordem em que devem
 * ser oferecidas. Um produto pode ter mais de uma ao mesmo tempo: quem usa a V2 e
 * ativou a V3 precisa continuar chegando nas duas.
 *
 * `external` só entra quando não há nenhuma área Cakto configurada — é a tela da
 * integração externa, não uma área a gerenciar.
 */
export function getMembersAreaTargets(contentDeliveries = []) {
  const targets = [];

  if (contentDeliveries.includes('cakto')) targets.push(MEMBERS_AREA_TARGET.V1);
  if (contentDeliveries.includes('cakto_v2')) targets.push(MEMBERS_AREA_TARGET.V2);
  if (contentDeliveries.includes(CAKTO_V3_DELIVERY_VALUE)) targets.push(MEMBERS_AREA_TARGET.V3);

  if (targets.length === 0 && contentDeliveries.includes('external')) {
    targets.push(MEMBERS_AREA_TARGET.EXTERNAL);
  }

  return targets;
}
